import i18next from "i18next";
import notifications from "services/notifications";
import store, { getStoreEntity } from "services/store";
import { getCurrentProjectID } from "state/auth/selectors/common";
import {
  maintenancePolicySelectionActions,
  maintenancePolicySelectionService,
} from "./services";
import { PolicySchema } from "utils/schemas";
import { maintenancePolicyDetailsFetcher } from "state/clusterdefinitions/services/templates";

export default class ClusterTemplateActions {
  constructor({ guid, maintenancePolicySubmit }) {
    this.guid = guid;
    this.maintenancePolicySubmit = maintenancePolicySubmit;
  }
  get state() {
    return store.getState().clusterTemplateModule?.[this.guid];
  }
  dispatch = (actionPayload) => {
    store.dispatch({
      ...actionPayload,
      guid: this.guid,
    });
  };
  async initialize({ fetchMaintenancePolicy, fetchLinkedProfiles }) {
    const maintenancePolicy = await fetchMaintenancePolicy();
    const linkedProfiles = await fetchLinkedProfiles();

    this.dispatch({
      type: "CLUSTER_TEMPLATE_INIT",
      maintenancePolicy,
      linkedProfiles,
    });
  }
  selectMaintenancePolicy = (selectedMaintenancePolicyGuid) => {
    this.dispatch({
      type: "CLUSTER_TEMPLATE_SET_SELECTED_MAINTENANCE_POLICY_GUID",
      selectedMaintenancePolicyGuid,
    });
  };
  onAddMaintenancePolicy = async () => {
    const currentProjectId = getCurrentProjectID(store.getState());

    try {
      store.dispatch(
        maintenancePolicySelectionActions.initialize(
          `maintenancePolicySelection/${currentProjectId}`
        )
      );
      maintenancePolicySelectionService.open().then(() => {
        const selectedMaintenancePolicyGuid =
          this.state.selectedMaintenancePolicyGuid;
        const selectedMaintenancePolicy = getStoreEntity(
          selectedMaintenancePolicyGuid,
          PolicySchema
        );
        store.dispatch(
          maintenancePolicyDetailsFetcher.fetch({
            uid: selectedMaintenancePolicy?.metadata?.uid,
            type: "maintenance",
          })
        );
        store.dispatch(
          this.maintenancePolicySubmit(selectedMaintenancePolicyGuid)
        );
      });
    } catch (error) {
      notifications.error({
        message: i18next.t(
          "Something went wrong while trying to fetch the maintenance policies"
        ),
        description: error.message,
      });
    }
  };
  setLoading = (loading) => {
    this.dispatch({
      type: "CLUSTER_TEMPLATE_SET_LOADING",
      loading,
    });
  };
}
